export enum Language {
  ENGLISH = 'en',
  ARABIC = 'ar',
  BENGALI = 'bn',
  BOSNIAN = 'bs',
  CATALAN = 'ca',
  CHINESE = 'cn',
  TRADITIONAL_CHINESE = 'zh',
  CROATIAN = 'hr',
  CZECH = 'cs',
  DANISH = 'da',
  DUTCH = 'nl',
  FINNISH = 'fi',
  FRENCH = 'fr',
  GERMAN = 'de',
  GREEK = 'el',
  GUJARATI = 'gu',
  HEBREW = 'he',
  HINDI = 'hi',
  HUNGARIAN = 'hu',
  INDONESIA = 'id',
  ITALIAN = 'it',
  JAPANESE = 'jp',
  KANNADA = 'kn',
  KOREAN = 'kr',
  MALAY = 'ms',
  MALAYALAM = 'ml',
  MARATHI = 'mr',
  NORWEGIAN = 'no',
  POLISH = 'pl',
  PORTUGUESE = 'pt',
  PUNJABI = 'pa',
  ROMANIAN = 'ro',
  RUSSIAN = 'ru',
  SERBIAN = 'sr',
  SLOVAKIAN = 'sk',
  SLOVENIAN = 'sl',
  SPANISH = 'es',
  SWEDISH = 'sv',
  TAGALOG = 'tl',
  TAMIL = 'ta',
  TELUGU = 'te',
  THAI = 'th',
  TURKISH = 'tr',
  UKRAINIAN = 'uk',
  VIETNAMESE = 'vn',
}

export const AllAcceptedFiles = {
  'application/vnd.ms-powerpoint': ['.pptx', '.ppt'],
  'application/msword': ['.doc', '.docx'],
  'application/pdf': ['.pdf'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg'],
  'font/ttf': ['.ttf'],
  'font/otf': ['.otf'],
  'text/hex': ['.hex'],
  'text/rgb': ['.rgb'],
  'image/webp': ['.webp'],
  'image/tiff': ['.tif', '.tiff'],
  'video/mp4': ['.mp4'],
  'video/quicktime': ['.mov'],
  'video/mpeg': ['.mpg', '.mpeg'],
  'video/x-msvideo': ['.avi'],
  'video/webm': ['.webm'],
  'video/x-ms-wmv': ['.wmv'],
};

export enum AssetType {
  RAW_FILE = 'RAW_FILE',
  LOGO = 'LOGO',
  FONT = 'FONT',
  COLORS = 'COLORS',
  PRODUCT = 'PRODUCT',
  VIDEO = 'VIDEO',
  KNOWLEDGE = 'KNOWLEDGE',
}

export enum RawFileCategory {
  BRAND_BOOK = 'BRAND_BOOK',
}

export enum ChatRole {
  HUMAN = 'human',
  AI = 'ai',
}

export enum Actions {
  ADD = 'Add',
  EDIT = 'Edit',
}

export enum RawFileTypes {
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
  PPT = 'ppt',
  PPTX = 'pptx',
}

export enum ColorCodeCategory {
  RGB = 'RGB',
  HEX = 'HEX',
}

export enum KnowledgeExtractionStatus {
  PENDING = 1,
  PROGRESS = 2,
  FAILURE = 3,
  SUCCESS = 4,
  BINNED = 5,
  TIMEOUT = 6,
  PARTIALSUCCESS = 7,
  VALIDATING = 8,
  INVALID = 9,
}

export enum PreviewType {
  TEXT = 'TEXT',
  DOCUMENT = 'DOCUMENT',
}

export enum SoketiEvents {
  ASSET_THUMBNAIL_GENERATED = 'ASSET_THUMBNAIL_GENERATED',
  ASSET_PREVIEW_GENERATED = 'ASSET_PREVIEW_GENERATED',
  KNOWLEDGE_EXTRACTION_PROGRESS = 'KNOWLEDGE_EXTRACTION:PROGRESS:',
  TAB_ASSET_CREATED = 'TAB_ASSET_CREATED',
  BULK_WORKSPACE_CREATION_PROGRESS = 'BULK_WORKSPACE_CREATION:PROGRESS:',
  TAB_ASSET_PROGRESS = 'TAB_ASSET_PROGRESS:',
  ASSET_EXPORT_STATUS = 'ASSET_EXPORT_STATUS',
}
